import { asyncPipeSpread } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import setFilterDateCreated from 'app/_shared/action/partial/filter/setDateCreated'
import apply from 'app/_shared/action/partial/filter/apply'
import { setProjectFilter, setReferenceFilter } from 'app/xEcoApm/action'

/**
 * Measurement Index Action
 *
 * Enables list filtering.
 *
 * @param {Gaia.AppModule.Spec} module  the current module object composition
 * @returns {function(*): function(...[*]): Promise<*>}
 */
export default module => component => async (...args) => asyncPipeSpread(
  setProjectFilter(module),
  setFilterDateCreated(module),
  setReferenceFilter(module),
  apply(module),
)(find(component), ...args)
